"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _helpers = require("../../../utils/helpers");
var _constants = require("../../../utils/constants");
var _formatters = require("../../../utils/formatters");
var _TypingIndicator = _interopRequireDefault(require("../../TypingIndicator/TypingIndicator"));
var _classnames = _interopRequireDefault(require("../../../utils/classnames"));
var _reactstrap = require("reactstrap");
var _GroupingImages = _interopRequireDefault(require("../../GroupingImages/GroupingImages"));
var _VideoMessage = _interopRequireDefault(require("../../MultimediaMessages/VideoMessage"));
var _AudiosMessage = _interopRequireDefault(require("../../MultimediaMessages/AudiosMessage"));
var _FileMessage = _interopRequireDefault(require("../../MultimediaMessages/FileMessage"));
require("./ChatMessage.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var urlFormat = function urlFormat(url, source) {
  url = Array.isArray(url) ? url.map(function (i) {
    return (0, _helpers.urlFormatHelper)(i, source);
  }) : (0, _helpers.urlFormatHelper)(url, source);
  return url;
};
var WhatsAppIconStatus = function WhatsAppIconStatus(_ref) {
  var status = _ref.status,
    messageId = _ref.messageId;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "t".concat(messageId),
    className: 'uin-chat-content-icon ' + status
  }, status !== 'sending' && /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + (status === 'error' || status === 'rejected' ? 'error' : (0, _helpers.cheksWhatsApp)(status))
  })), messageId && status === 'rejected' && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "t".concat(messageId)
  }, t('whatsapp:rejectedMessage')));
};
var ChatBubble = function ChatBubble(_ref2) {
  var status = _ref2.status,
    source = _ref2.source,
    type = _ref2.type,
    children = _ref2.children,
    messageId = _ref2.messageId;
  var showStatus = function showStatus() {
    return (0, _helpers.isNewMedia)(type) && (source === _constants.MSG_SOURCE.AGENT || source === _constants.MSG_SOURCE.ADMIN);
  };
  var whatsAppStatus = function whatsAppStatus() {
    return showStatus() && /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-whatsapp-status"
    }, /*#__PURE__*/_react["default"].createElement(WhatsAppIconStatus, {
      status: status,
      messageId: messageId
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-bubble"
  }, status === 'sending' && showStatus() && /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    size: "sm",
    color: "primary",
    className: "loadIcon"
  }), children, whatsAppStatus());
};
var ImageGrouping = function ImageGrouping(_ref3) {
  var status = _ref3.status,
    source = _ref3.source,
    type = _ref3.type,
    attachments = _ref3.attachments,
    messageIds = _ref3.messageIds;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return attachments.reduce(function (acc, att) {
    if (!att.url) return [].concat(_toConsumableArray(acc), [{
      unavailable: true
    }]);else {
      if (!acc[acc.length - 1] || !acc[acc.length - 1].attachments || att.caption) acc.push({
        attachments: []
      });
      acc[acc.length - 1].attachments.push(att);
      return acc;
    }
  }, []).map(function (group, i) {
    return group.unavailable ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
      key: i,
      status: status,
      source: source,
      type: type,
      messageId: messageIds[i]
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text error"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon warning"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text-link"
    }, t('whatsapp:notAvailable')))) : /*#__PURE__*/_react["default"].createElement(ChatBubble, {
      key: i,
      status: status,
      source: source,
      type: type,
      messageId: messageIds[i]
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-image"
    }, /*#__PURE__*/_react["default"].createElement(_GroupingImages["default"], {
      arr: urlFormat(group.attachments.map(function (a) {
        return a.url;
      }), source)
    }), group.attachments[0].caption && /*#__PURE__*/_react["default"].createElement("span", {
      className: "uin-chat-image-caption"
    }, (0, _helpers.linebreaks)((0, _helpers.linkify)(group.attachments[0].caption)))));
  });
};
var ChatMessage = function ChatMessage(_ref4) {
  var source = _ref4.source,
    image = _ref4.image,
    typing = _ref4.typing,
    content = _ref4.content,
    status = _ref4.status,
    date = _ref4.date,
    disabled = _ref4.disabled,
    type = _ref4.type,
    speedSelected = _ref4.speedSelected,
    changeSpeed = _ref4.changeSpeed,
    setCurrentAudio = _ref4.setCurrentAudio,
    currentAudio = _ref4.currentAudio,
    fromAgent = _ref4.fromAgent,
    isEnableHistoricalChat = _ref4.isEnableHistoricalChat;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(['commons', 'whatsapp']),
    t = _useTranslation3.t;
  var classes = (0, _classnames["default"])({
    disabled: disabled,
    response: source !== _constants.MSG_SOURCE.USER,
    admin: source === _constants.MSG_SOURCE.ADMIN,
    coaching: source === _constants.MSG_SOURCE.COACH
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-chat-message ' + classes
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chat-time"
  }, (source === _constants.MSG_SOURCE.ADMIN || source === _constants.MSG_SOURCE.COACH) && /*#__PURE__*/_react["default"].createElement("span", {
    id: 'uin-chat-msg-vis-' + source.charAt(0),
    className: "uin-chat-label"
  }, t('admin')), isEnableHistoricalChat && source === _constants.MSG_SOURCE.AGENT && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chat-label"
  }, fromAgent), !typing && /*#__PURE__*/_react["default"].createElement("time", {
    dateTime: date == null ? new Date() : date
  }, (0, _formatters.formatTimeShort)(date == null ? new Date() : date))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-content"
  }, source === _constants.MSG_SOURCE.USER && image, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-body"
  }, typing ? /*#__PURE__*/_react["default"].createElement(_TypingIndicator["default"], {
    contained: true
  }) : content.map(function (c, i) {
    return c.type === 'text' || c.type === 'template' ? c.texts.map(function (text, j) {
      return /*#__PURE__*/_react["default"].createElement(ChatBubble, {
        id: i + '-' + j,
        key: i + '-' + j,
        status: c.status || status,
        source: source,
        type: type,
        messageId: c.messageIds[j]
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "uin-chat-text"
      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(text))));
    }) : c.type === 'unsupported' ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
      key: i,
      status: c.status || status,
      source: source,
      type: type,
      messageId: c.messageIds[i]
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text error"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon warning"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text-link"
    }, t('whatsapp:unsupported')))) : !c.attachments || !Array.isArray(c.attachments) || c.attachments.length === 0 ? /*#__PURE__*/_react["default"].createElement(ChatBubble, {
      key: i,
      status: c.status || status,
      source: source,
      type: type,
      messageId: c.messageIds[i]
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text error"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon warning"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-chat-text-link"
    }, t('whatsapp:notAvailable')))) : c.type === 'image' ? /*#__PURE__*/_react["default"].createElement(ImageGrouping, {
      key: i,
      status: c.status || status,
      source: source,
      type: type,
      attachments: c.attachments,
      messageIds: c.messageIds
    }) : c.attachments.map(function (_ref5, j) {
      var url = _ref5.url,
        name = _ref5.name,
        size = _ref5.size,
        caption = _ref5.caption;
      return /*#__PURE__*/_react["default"].createElement(ChatBubble, {
        key: i + '-' + j,
        status: c.status || status,
        source: source,
        type: type,
        messageId: c.messageIds[i]
      }, !url || !(0, _helpers.isValidURL)(urlFormat(url, source)) ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "uin-chat-text error"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "gcl-icon warning"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "uin-chat-text-link"
      }, t('whatsapp:' + (!url ? 'notAvailable' : 'unsupported')))) : c.type === 'location' ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "uin-chat-text"
      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(url))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "uin-chat-image"
      }, c.type === 'video' ? /*#__PURE__*/_react["default"].createElement(_VideoMessage["default"], {
        url: urlFormat(url, source)
      }) : c.type === 'file' ? /*#__PURE__*/_react["default"].createElement(_FileMessage["default"], {
        url: urlFormat(url, source),
        size: size,
        name: name
      }) : c.type === 'audio' ? /*#__PURE__*/_react["default"].createElement(_AudiosMessage["default"], {
        url: urlFormat(url, source),
        changeSpeed: changeSpeed,
        speedSelected: speedSelected,
        image: image,
        source: source,
        currentAudio: currentAudio,
        setCurrentAudio: setCurrentAudio,
        disabled: disabled
      }) : null, caption && /*#__PURE__*/_react["default"].createElement("span", {
        className: "uin-chat-image-caption"
      }, (0, _helpers.linebreaks)((0, _helpers.linkify)(caption)))));
    });
  })), (source === _constants.MSG_SOURCE.AGENT || source === _constants.MSG_SOURCE.ADMIN) && !(0, _helpers.isNewMedia)(type) && (status === 'delivered' ? /*#__PURE__*/_react["default"].createElement("i", {
    id: "uin-chat-msg-dlr",
    className: "gcl-icon selected"
  }) : /*#__PURE__*/_react["default"].cloneElement(image, {
    id: 'uin-chat-msg-rd'
  })))));
};
ChatMessage.propTypes = {
  source: _propTypes["default"].oneOf(Object.values(_constants.MSG_SOURCE)),
  typing: _propTypes["default"].bool,
  content: _propTypes["default"].arrayOf(_propTypes["default"].object),
  status: _propTypes["default"].string,
  date: _propTypes["default"].instanceOf(Date),
  disabled: _propTypes["default"].bool
};
ChatMessage.defaultProps = {
  source: _constants.MSG_SOURCE.USER,
  status: 'delivered'
};
var _default = exports["default"] = ChatMessage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ChatView/ChatMessage.js
// module id = 1401
// module chunks = 0